import {UseCase} from '@s-ui/domain'

class GetAuthenticationTrackingUseCase extends UseCase {
  constructor({service, gigyaEventFactory}) {
    super({
      service,
      gigyaEventFactory
    })

    this._service = service
    this._gigyaEventFactory = gigyaEventFactory
  }

  _getScreenSet = event => (event.currentScreen ? event.currentScreen : this._getScreenSetFromValidation(event))

  _getScreenSetFromValidation = event => (event.screen ? event.screen : this._getScreenSetFromResponse(event))

  _getScreenSetFromResponse = event => (event.response ? event.response.info.screen : '')

  _getErrorCode = event => {
    if (event.formErrors) {
      return Object.keys(event.formErrors).map(field => {
        return event.formErrors[field]?.errorCode
      })[0] // Only returning first error
    } else {
      return event.errorCode
    }
  }

  async execute({event}) {
    const gigyaEvent = this._gigyaEventFactory({
      eventName: event.eventName,
      screenSet: this._getScreenSet(event),
      formData: event.formData || {},
      errorCode: this._getErrorCode(event)
    })

    const {segmentEventProps} = await this._service.execute({
      gigyaEvent
    })

    return {
      segmentEventProps
    }
  }
}

export default GetAuthenticationTrackingUseCase
